import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/home/Index";
import NotFound from "./pages/not-found/Index";
import CarDetailing from "./pages/car-detailing/Index";
import VideoReview from "./pages/video-review/Index";
import MotveBrake from "./pages/motve/Index";
import AboutUs from "./pages/about/Index";
import Products from "./pages/products/Index";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Sonner />
      <HashRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/car-detailing" element={<CarDetailing />} />
          <Route path="/reviews" element={<VideoReview />} />
          <Route path="/motve" element={<MotveBrake />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/products" element={<Products />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
